<script>
    /**
     * 高阶组件，传递参数生成另一个组件
     */
    export default {
        name: 'LyHoc',
        props: {
            value: [Object, Array, String, Number, Boolean],
            power: { // 2020-08-03 by zjs 增加权限的识别
                type: [Array, Object, Boolean],
                default: _ => new Array()
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }, // 此容器组件的所有配置信息
            page: {
                type: Object,
                default: _ => new Object()
            } // 此组件所在页面的数据，容器组件才会，datepicker也在用
        },
        /**
         * 通过JSX语法渲染节点
         */
        render (h) {
            if (this.isShow()) {
                let elName = this.$props.attrs.name
                return h(elName, {
                    on: this.$listeners,
                    attrs: this.$attrs,
                    props: this.$props
                })
            }
        },
        methods: {
            /**
             * 根据传入的power，对比当前组件的label，判断是否显示,以实现权限的控制
             * @time 2020-08-03
             * @author zjs
             */
            isShow () {
                let bool = true
                let power = this.$props.power
                let label = this.$props.attrs.label
                for (let i = 0, len = power.length; i < len; i++) {
                    if (power[i]['label'] == label) {
                        if (power[i]['isShow'] === false) {
                            bool = false
                        }
                        break;
                    }
                }
                return bool
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/hoc/src/index.vue